import { CSS, StyleProps } from "@shared/primitive-components"

export const red = (props: StyleProps): CSS => ({
  color: props.theme.palette.full.red,
})

export const green = (props: StyleProps): CSS => ({
  color: props.theme.palette.full.green,
})

export const darkBoldHeader = (props: StyleProps): CSS => ({
  color: props.theme.palette.coal.dark,
  fontWeight: `bold`,
})
